import { supabaseClient } from "supabase/supabase";

export const queryEventByID = async ({ uid }: { uid: string }) => {
  const query = supabaseClient
    .from("events")
    .select("*,venues(*)")
    .eq("uid", uid);
  const { data, error } = await query;
  if (error) {
    throw error;
  }
  return data![0];
};
